import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { PlacaVideo } from '../model';
import { Gabinete } from '../model/Gabinete';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_VideoGabinete extends FuncionCompatilibidadBase<PlacaVideo, Gabinete> {
  funciones = {
    altura: (video: PlacaVideo, gabinete: Gabinete): Incompatibilities | null =>
      video.$caracteristicas.largo > gabinete.$caracteristicas.largo_maximo_vga ?
        {
          tipo: IncompatibilitiesType.PRODUCTO,
          incompatibility: 'La placa de video es demasiado grande para el gabinete ',
        }
      : null,
  };
}
